export const SceneRevealMode = {
    Default: 0,
    Gradual: 1,
    Instant: 2
};
